import React from 'react'

import styled from '@emotion/styled'
import { mq, grayBorder, green01, hoverFade, breakP, gray02, contentWidth } from '../../_style'
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Banner from '../atoms/banner';
import { css } from '@emotion/core';

const Container = styled.div`
  .slick-slider {
    ${props => props.inMenu && `
      padding-top: 10px;
      margin-bottom: 90px;
    `}
    ${props => props.inNav && `
      padding-top: 60px;
    `}
    .slick-track {
      font-size: 0;
    }
    ${mq.pc} {
      padding-bottom: 60px;
    }
    ${mq.sp} {
      margin-left: -20px;
      margin-right: -20px;
    ${props => props.inNav && `
      margin-left: 0px;
      margin-right: 0px;
    `}
    }
  }
  .slick-slide {
    ${mq.pc} {
      &:not(.slick-active) {
        opacity: 0.4;
        pointer-events: none;
      }
    }
  }
  .slick-dots {
    bottom: -33px;
    li {
      margin: 0 2px;
      button {
        &::before {
          content: "";
          left: 0;
          right: 0;
          bottom: 0;
          width: 7px;
          height: 7px;
          opacity: 1;
          margin: auto;
          border-radius: 50%;
          border: solid 1px ${gray02};
        }
      }
    }
    .slick-active {
      button {
        &::before {
          width: 8px;
          height: 8px;
          background-color: ${green01};
          border: solid 1px #fff;
        }
      }
    }
  }
  ${mq.pc} {
    .slick-track {
      display: flex;
      justify-content: center;
      .slick-slide {
        width: calc((100% - (25px * 4)) / 5);
        & + .slick-slide {
          margin-left: 20px;
        }
      }
    }
  }
  .slick-list {
    ${mq.sp} {
      padding-left: 15px;
    }
  }
`

const BannerSliderInner = styled.div`
  ${mq.sp} {
    ${props => props.onlyPc && `display: none;`}
  }
  ${mq.pc} {
    ${props => props.onlySp && `display: none;`}
  }
`

const Item = styled.div`
  ${mq.sp} {
    width: 100%;
    padding: 0 5px;
  }
`
const arrowStyle = css`
  position: absolute;
  bottom: 0;
  cursor: pointer;
  ${hoverFade}
`

const NextArrowContainer = styled.div`
position: relative;
  .slick-arrow {
    ${arrowStyle}
    top: 53px;
    right: .2%;
    svg {
      fill: ${green01}
    }
    &::before {
      display: none;
    }
    &.slick-disabled {
      visibility: hidden;
    }
  }
`
const PrevArrowContainer = styled.div`
position: relative;
  .slick-arrow {
    ${arrowStyle}
    top: 118px;
    left: 92.3%;
    svg {
      fill: ${green01}
    }
    &::before {
      display: none;
    }
    &.slick-disabled {
      visibility: hidden;
    }
  }
`

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <NextArrowContainer>
      <div className={className} onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21.79" height="11.67" viewBox="0 0 21.79 11.67"><path d="M0 5.33h20L15.79.67l.74-.67 5.26 5.83-5.26 5.84-.74-.67L20 6.33H0v-1z"/></svg>
      </div>
    </NextArrowContainer>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <PrevArrowContainer>
      <div className={className} onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21.79" height="11.67" viewBox="0 0 21.79 11.67"><path d="M21.79 5.33H1.8L6 .67 5.26 0 0 5.83l5.26 5.84L6 11 1.8 6.33h19.99v-1z"/></svg>
      </div>
    </PrevArrowContainer>
  );
}

export default class BannerList extends React.Component {

  render() {

    const bannerSliderConfigPc = {
      variableWidth: false,
      slidesToShow: 4,
      infinite: false,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    }

    const bannerSliderConfigSp = {
      dots: true,
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      arrows: false,
    }

    return(
      <Container inMenu={this.props.inMenu} inNav={this.props.inNav}>
        <BannerSliderInner onlyPc>
          <Slider {...bannerSliderConfigPc}>
            {this.props.banners.map((item, index) => {
              return (<Item key={index}>
                <Banner img={item.img} to={item.to ? item.to : null} href={item.href ? item.href : null} alt={item.alt} isBlank={item.isBlank ? true : null} isNew={item.isNew ? true : null}></Banner>
              </Item>)
            })}
          </Slider>
        </BannerSliderInner>
        <BannerSliderInner onlySp>
          <Slider {...bannerSliderConfigSp}>
            {this.props.banners.map((item, index) => {
              return (<Item key={index}>
                <Banner img={item.img} to={item.to ? item.to : null} href={item.href ? item.href : null} alt={item.alt} isBlank={item.isBlank ? true : null} isNew={item.isNew ? true : null}></Banner>
              </Item>)
            })}
          </Slider>
        </BannerSliderInner>
      </Container>
    )
  }
}
